// Which deployment this build is. Every build reads its own .env.<APP_ENV>
// (webpack.config.js): production's says PROD, and beta, uat, development and docker
// each name themselves. Anything that is not PROD is a testing deployment - a file
// that has lost the key shows the badge rather than quietly passing as production.
export const DEPLOYMENT_ENV = process.env.REACT_APP_PUBLIC_ENV || null;

export const IS_PRODUCTION_BUILD = DEPLOYMENT_ENV === 'PROD';
